import { MenuItem, Select, Tooltip } from "@material-ui/core";
import { useState } from "react";
import { connect } from "react-redux";
import { updateInsuranceSelection } from "../../store/limitAndPaymentInformation/actions";
import { getNumberFormat, infoTexts } from "../../utils/enums";
import InfoIcon from "@material-ui/icons/Info";

const InterestRatesColumns = (props) => {
  return [
    { field: "id", headerName: "ID", width: 90, hide: true },
    {
      field: "limitType",
      headerName: "Limit Tipi",
      headerAlign: "center",
      sortable: false,
      minWidth: 130,
      flex: 1,
      selected: true,
      valueGetter: (params) => {
        return params.value === "TTK" ? "Ticari Taksitli Kredi" : params.value;
      },
    },
    {
      field: "installmentNumber",
      headerName: "Taksit",
      width: 70,
      sortable: false,

      align: "center",
      headerAlign: "center",
    },
    {
      field: "interestRate",
      headerName: "Faiz",
      sortable: false,

      width: 90,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => {
        return "%" + getNumberFormat(params.value);
      },
    },
    {
      field: "insuranceFlag",
      headerName: "Sigorta",
      sortable: false,
      flex: 1,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Select
            value={params.row.insuranceSelection}
            onChange={(ev) => {
              props.dispatch(updateInsuranceSelection({
                id: params.row.id,
                insuranceSelection: ev.target.value,
              }));
            }}
            disabled={params.row.insuranceFlag === "1"}
          >
            <MenuItem value={"Seçiniz"}>Seçiniz..</MenuItem>
            <MenuItem value={"Evet"}>Evet</MenuItem>
            <MenuItem value={"Hayır"}>Hayır</MenuItem>
          </Select>
        );
      },
    },
    {
      field: "usableAmount",
      headerName: "Kullanılabilir Limit",
      sortable: false,
      flex: 1,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const showInfo =
          params.row.insuranceSelection === "Evet" &&
          params.row.customerReachedFlag === "1";
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {getNumberFormat(params.value)}
            {showInfo && (
              <Tooltip
                title={
                  infoTexts.BM0003_PREFIX +
                  infoTexts.BM0003_SUFFIX
                }
              >
                <InfoIcon fontSize="small" color="disabled" style={{ marginLeft: 5 }} />
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];
};

const mapStateToProps = (state) => {
  return {
    processContext: state.processContext,
    limitAndPaymentInformation: state.limitAndPaymentInformation,
  };
};

export default connect(mapStateToProps)(InterestRatesColumns);
